import React from 'react';

const ApplicantRoot = React.lazy(() => import('@application/applicant'));
const BackofficeRoot = React.lazy(() => import('@application/backoffice'));
const MgmtRoot = React.lazy(() => import('@application/mgmt'));
const ApplicantHeadlessRoot = React.lazy(() => import('@application/headless/applicant'));
const BackofficeHeadlessRoot = React.lazy(() => import('@application/headless/backoffice'));

const ModuleMap = {
  applicant: ApplicantRoot,
  applicant_headless: ApplicantHeadlessRoot,
  backoffice: BackofficeRoot,
  backoffice_headless: BackofficeHeadlessRoot,
  mgmt: MgmtRoot,
};

const App: React.FC = () => {
  const ModuleRoot = ModuleMap[window.FF_MODULE] ?? ApplicantRoot;

  return <ModuleRoot />;
};

export default App;
